export const conflictingSources: string[] = [
  'One video explains how to wire a three-way switch.',
  'A textbook chapter covers Ohm’s law.',
  'A handout from years ago explains motor control circuits.',
  'Your old notes cover lockout/tagout.',
]

export const symptoms: string[] = [
  'And when you need material for lab safety, circuit theory, residential wiring, motors, diagrams, troubleshooting, PLCs or assessments...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next class or workshop arrives.'

export const needsList: string[] = [
  'You need a clear visual of the circuit, the device or the wiring method.',
  'You need the installation and testing steps broken down one by one.',
  'You need lab exercises and circuit-building activities that actually engage your students.',
  'You need ❌/✅ comparisons that correct the most common wiring and testing mistakes.',
  'And you need a clear way to see who is really ready for the next level.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s class?',
  'How do I explain voltage, current and resistance so students truly understand them?',
  'How do I teach three-way switching and panel terminations step by step?',
  'How do I correct reversed polarity and loose terminations that keep coming back?',
  'How do I make schematics and ladder diagrams click for every student?',
  'How do I teach troubleshooting with a safe, systematic method?',
  'Where do I find clear visual material for motors, PLCs and VFDs?',
  'How can I plan better classes without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding classes and workshops from scratch every week.',
  'Hours searching scattered books, videos, handouts and notes.',
  'Explaining circuits, current flow and control logic with words alone.',
  'Students following steps without understanding why.',
  'No visual material for the lab bench, the training panel or the classroom.',
  'Repeating the same corrections every class.',
  'Assessing wiring and testing skills without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next class will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT ERRORS.',
  'HOW TO STRUCTURE THE CLASS.',
  'HOW TO ASSESS EACH SKILL.',
]
